import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { ThemeProvider } from './contexts/ThemeContext';
import { useKonamiCode } from './hooks';
import { playOneUpSound } from './utils/sounds';
import LifeCounter from './components/shared/LifeCounter';

// Pages
import HomePage from './components/pages/HomePage';
import AboutPage from './components/pages/AboutPage';
import ProjectsPage from './components/pages/ProjectsPage';
import PhilosophyPage from './components/pages/PhilosophyPageExpanded';
import CommercialBreakerPage from './components/pages/CommercialBreakerPage';
import LicensePage from './components/pages/LicensePage';
import NotFoundPage from './components/pages/NotFoundPage';

// Console messages easter egg
const logConsoleMessages = () => {
  console.log('%cWelcome to theweebcoders', 'font-size: 24px; color: #00CED1; font-weight: bold;');
  console.log('%cYou\'re viewing the source? Of course you are. You\'re a developer.', 'font-size: 14px; color: #A0A0A0;');
  console.log('%cWant to contribute? Check out our GitHub: https://github.com/theweebcoders', 'font-size: 14px; color: #1E90FF;');
  console.log('%c\nPro tips:', 'font-size: 16px; color: #FFD700; font-weight: bold;');
  console.log('%c- Press the same number key (0-4) five times to change themes', 'font-size: 12px; color: #A0A0A0;');
  console.log('%c\nEverything here is public domain. No licenses. Take it. Fork it. We don\'t care.', 'font-size: 12px; color: #00FF88;');
  console.log('%c\nEl. Psy. Kongroo.', 'font-size: 14px; color: #FF6EC7; font-style: italic;');
};

const AppContent: React.FC = () => {
  const [lives, setLives] = useState(0);

  // Konami code easter egg - gives you a 1-up!
  useKonamiCode(() => {
    playOneUpSound();
    setLives(prev => prev + 1);
  });

  useEffect(() => {
    logConsoleMessages();
  }, []);

  return (
    <BrowserRouter>
      <LifeCounter lives={lives} />
      <AnimatePresence mode="wait">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/commercial-breaker" element={<CommercialBreakerPage />} />
          <Route path="/philosophy" element={<PhilosophyPage />} />
          <Route path="/license" element={<LicensePage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </AnimatePresence>
    </BrowserRouter>
  );
};

function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}

export default App;
